type ModuleType = typeof import("dayjs/locale/en");
/**
 * @description This object is used to dynamically import the locale files
 * or to use the default locale which is a string.
 * Uses require() under Metro (React Native) and import() under Vite (web).
 */
export const LOCALE_IMPORTS: { [key: string]: () => Promise<ModuleType> } = {
  fr: () =>
    typeof require !== "undefined"
      ? (Promise.resolve(require("dayjs/locale/fr")) as Promise<ModuleType>)
      : import("dayjs/locale/fr"),
  it: () =>
    typeof require !== "undefined"
      ? (Promise.resolve(require("dayjs/locale/it")) as Promise<ModuleType>)
      : import("dayjs/locale/it"),
  de: () =>
    typeof require !== "undefined"
      ? (Promise.resolve(require("dayjs/locale/de")) as Promise<ModuleType>)
      : import("dayjs/locale/de"),
};
